// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notifications[data-v-1649291e] {\n  max-width: 1200px;\n}\n.notification-card[data-v-1649291e] {\n  width: 100%;\n}\n.notification-history-card[data-v-1649291e] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
